module.exports = __webpack_public_path__ + "static/4c1c2349.AE-328-en.png";